import React, {Component} from 'react';
import {connect} from 'react-redux';

import axios from "axios";

import urls from "../../../utils/urls";
import {ajaxHandler} from "../../../utils/errors";
import {tokenHeader} from "../../../utils/headers";
import PageNotFound from '../../../components/PageNotFound/pageNotFound';
import { Spinner } from '../../../components/Loading/Spinner';
import helpers from '../../../utils/helpers';
import Header from '../../Header/index';

import TripFE from '../Trips/Trip/index';
import TripInternal from '../InternalTrips/Trip/index';

class Trip extends Component {

    constructor(props) {
        super(props);

        const {id} = this.props.match.params;

        this.state = {
            trip: false,
            tripId: id ? id : null,
            ajaxInProgress: false
        }
    }

    componentDidMount() {
        this._fetchTrip();
    }

    _fetchTrip = () => {
        // To reload trip
        if(this.state.trip){this.setState({trip: false});};

        let {tripId} = this.state;
        if(!tripId || isNaN(tripId)){return false;}

        let TRIP_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.tripId}/`;
        axios
            .get(TRIP_URL, tokenHeader())
            .then(response => {
                this.setState({trip: response.data, activeStep: null}, this.props.reloadedTrip);
            })
            .catch(error => {
                try{
                    let response = error.response;
                    if(response.status === 404){
                        // To redirect user to 404 page, set a non-existant id
                        this.setState({tripId: 'idNotFound'})
                    }else{
                        ajaxHandler(error);
                    }
                }
                catch (e){
                    ajaxHandler(error);
                }
            });
    };

    render() {
        let {trip, tripId} = this.state;

        // Security check
        if(!this.props.user || !tripId || isNaN(tripId)){
            return <PageNotFound />;
        }

        // Waiting for options
        if(!trip){
            return (
                <div className={"main-dashboard"}>
                    <Header active={"new-trip"} />
                    <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                        <Spinner />
                    </div>
                </div>
            );
        }

        if(trip.trip_type === helpers.trip_type.INTERNAL){
            return <TripInternal fetchedTrip={trip} />;
        }
        return <TripFE fetchedTrip={trip} />;
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

export default connect(mapStateToProps)(Trip);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Home/Trip.js